import Alpine from 'alpinejs';
import 'regenerator-runtime/runtime';
import { breakpoint } from '../../src/js/vendorjs/breakpoint-helper.vendor';

export const menuItem = () => {
  Alpine.data('menuItem', (hasSubMenu = false) => ({
    hasSubMenu,
    subMenuIsOpen: false,
    init() { },
  }));
};
